module.exports = __webpack_public_path__ + "media/images/iconClose-8dada38343a5c2f065667156f6085f79.png";